import { render } from "./BlogsPage.vue?vue&type=template&id=7e77b208"
import script from "./BlogsPage.vue?vue&type=script&lang=js"
export * from "./BlogsPage.vue?vue&type=script&lang=js"

import exportComponent from "/home/zhayrullah/projects/laravel/mawthuq/front-mawthuq/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__